import { render, staticRenderFns } from "./FIFAssets.vue?vue&type=template&id=997d559c&"
import script from "./FIFAssets.vue?vue&type=script&lang=js&"
export * from "./FIFAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports